/**
 * Client feature flags. Liquor module OFF unless REACT_APP_LIQUOR_MODULE is truthy.
 * POS module OFF unless REACT_APP_POS_MODULE is truthy.
 * See docs/liquor-design.md
 */

function envFlag(name: string, defaultValue = false): boolean {
  const raw = process.env[name];
  if (raw === undefined || raw === null || raw === '') return defaultValue;
  const v = String(raw).trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(v)) return true;
  if (['0', 'false', 'no', 'off'].includes(v)) return false;
  return defaultValue;
}

export const featureFlags = {
  liquorModule: envFlag('REACT_APP_LIQUOR_MODULE', false),
  posModule: envFlag('REACT_APP_POS_MODULE', false),
};

export function isLiquorModuleEnabled(): boolean {
  return featureFlags.liquorModule;
}

export function isPosModuleEnabled(): boolean {
  return featureFlags.posModule;
}
